import { useSelector } from 'react-redux';
import {
    Button,
    TextField,
    Autocomplete,
    CircularProgress,
    ToggleButton,
    ToggleButtonGroup
} from '@mui/material';
import {
    AccountBalance,
    Payments,
    Save,
    BorderColor
} from '@mui/icons-material';
import ShowDoneIconOnSelect from '../../../../../../icons/ShowDoneIconOnSelect';
import useBankInfo from '../hooks/useBankInfo';
import { H4 } from '../../../../../../themes/typography';

// TODO: Only load this component if bank details are present. Else show the "Add Bank Details" component with popup to add bank details. [Need Backend] [Done]
// TODO: Show select bank account option in "Nickname" + "Bank Account Number" format. [Need Backend] [Done]
// TODO: Show the selected bank account details in the form fields when a bank account is selected. [Need Backend][Done]
// TODO: Show the pre-selected bank account details when the form is opened and same in platform fees payable information. [Need Backend][Pending]
// TODO: Save Changes form with api is working. [Need to test with backend] [not working yet in backend][Done]

export default function BankInfo() {
    const bankDetails = useSelector((state) => state.bank.bankDetails);
    const {
        formik,
        handleBankAccountSelection,
        loading,
        isCommissionPaidByEndUserProvided
    } = useBankInfo();

    return (
        <form className="bank-info-container" onSubmit={formik.handleSubmit}>
            <div className="bank-info-main">

                {/* 
                <div className="invoice-info-main-container">
                    <div id="personal-info-form">
                        <div className="invoice-info-header">
                            <div className="invoice-info-title">
                                <span className="invoice-info-icon">
                                    <Payments color="secondary" sx={{ fontSize: '1.75rem' }} />
                                </span>
                                <H4 fontWeight={600}>Platform Fees Payable Information</H4>
                            </div>
                            {!isCommissionPaidByEndUserProvided && (
                                <div className="invoice-info-edit-button">
                                    <Button
                                        variant="text"
                                        type="button"
                                        startIcon={
                                            loading && formik.values.isCommissionEditable ? (
                                                <CircularProgress size={20} color="inherit" />
                                            ) : formik.values.isCommissionEditable ? (
                                                <Save />
                                            ) : (
                                                <BorderColor />
                                            )
                                        }
                                        disableRipple
                                        onClick={() => {
                                            if (formik.values.isCommissionEditable) {
                                                formik.handleSubmit();
                                            } else {
                                                formik.setFieldValue('isCommissionEditable', true);
                                            }
                                        }}
                                    >
                                        {formik.values.isCommissionEditable ? (loading ? 'Saving' : 'Save') : 'Edit'}
                                    </Button>
                                </div>
                            )}
                        </div>
                        <div className="invoice-info-body">
                            <div className="invoice-info-details">
                                <div className="invoice-info-two-inputs">
                                    <div className="invoice-info-input-field">
                                        <ToggleButtonGroup
                                            color="main"
                                            value={formik.values.commissionPayableByEndUser}
                                            exclusive
                                            onChange={(event, newSelected) =>
                                                formik.setFieldValue(
                                                    'commissionPayableByEndUser',
                                                    newSelected
                                                )
                                            }
                                            aria-label="Platform fees payable by"
                                            sx={{ gap: '1.5rem' }}
                                            disabled={isCommissionPaidByEndUserProvided}
                                        >
                                            <ToggleButton value={false}>
                                                Me
                                                {formik.values.commissionPayableByEndUser ===
                                                    false && <ShowDoneIconOnSelect />}
                                            </ToggleButton>
                                            <ToggleButton value={true}>
                                                Buyer
                                                {formik.values.commissionPayableByEndUser ===
                                                    true && <ShowDoneIconOnSelect />}
                                            </ToggleButton>
                                        </ToggleButtonGroup>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                 */}

                <div className="selected-bank-info">
                    <div className="invoice-info-main-container">
                        <div id="personal-info-form">
                            <div className="invoice-info-header">
                                <div className="invoice-info-title">
                                    <span className="invoice-info-icon">
                                        <AccountBalance
                                            color="secondary"
                                            sx={{ fontSize: '1.75rem' }}
                                        />
                                    </span>
                                    <H4 fontWeight={600}>Linked Banking Information</H4>
                                </div>
                                <div className="invoice-info-edit-button">
                                    <Button
                                        variant="text"
                                        type="button"
                                        startIcon={
                                            loading && formik.values.isEditable ? (
                                                <CircularProgress size={20} color="inherit" />
                                            ) : formik.values.isEditable ? (
                                                <Save />
                                            ) : (
                                                <BorderColor />
                                            )
                                        }
                                        disableRipple
                                        onClick={() => {
                                            if (formik.values.isEditable) {
                                                formik.handleSubmit();
                                            } else {
                                                formik.setFieldValue('isEditable', true);
                                            }
                                        }}
                                    >
                                        {formik.values.isEditable ? (loading ? 'Saving' : 'Save') : 'Edit'}
                                    </Button>
                                </div>
                            </div>
                            <div className="invoice-info-body">
                                <div className="invoice-info-details">
                                    <div className="invoice-info-two-inputs">
                                        <div className="invoice-info-input-field">
                                            <Autocomplete
                                                fullWidth
                                                id="selectBankAccount"
                                                name="selectBankAccount"
                                                options={bankDetails?.data || []}
                                                getOptionLabel={(option) => option.nickname}
                                                onChange={handleBankAccountSelection}
                                                value={formik.values.selectedBankAccount}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Select Bank Account"
                                                    />
                                                )}
                                                renderOption={(props, option) => (
                                                    <li {...props}>
                                                        <span className="bank-account-option">
                                                            {option.nickname} -{' '}
                                                            {option.account_number}
                                                        </span>
                                                    </li>
                                                )}
                                                disabled={!formik.values.isEditable}
                                            />
                                        </div>
                                        {/* <div className='invoice-info-input-field'></div> */}
                                    </div>
                                    <div className="invoice-info-two-inputs">
                                        <div className="invoice-info-input-field">
                                            <TextField
                                                disabled
                                                fullWidth
                                                id="bankName"
                                                name="bankName"
                                                label="Bank Name"
                                                value={formik.values.bankName}
                                            />
                                        </div>
                                        <div className="invoice-info-input-field">
                                            <TextField
                                                disabled
                                                fullWidth
                                                id="accountHolderName"
                                                name="accountHolderName"
                                                label="Account Holder Name"
                                                value={formik.values.accountHolderName}
                                            />
                                        </div>
                                    </div>
                                    <div className="invoice-info-two-inputs">
                                        <div className="invoice-info-input-field">
                                            <TextField
                                                disabled
                                                fullWidth
                                                id="accountNumber"
                                                name="accountNumber"
                                                label="Account Number"
                                                value={formik.values.accountNumber}
                                            />
                                        </div>
                                        <div className="invoice-info-input-field">
                                            <TextField
                                                disabled
                                                fullWidth
                                                id="ifscCode"
                                                name="ifscCode"
                                                label="IFSC Code"
                                                value={formik.values.ifscCode}
                                            />
                                        </div>
                                    </div>
                                    <div className="invoice-info-two-inputs">
                                        <div className="invoice-info-input-field">
                                            <TextField
                                                disabled
                                                fullWidth
                                                id="accountType"
                                                name="accountType"
                                                label="Account Type"
                                                value={formik.values.accountType.toUpperCase()}
                                            />
                                        </div>
                                        <div className="invoice-info-input-field">
                                            <TextField
                                                disabled
                                                fullWidth
                                                id="nickName"
                                                name="nickName"
                                                label="Nick Name"
                                                value={formik.values.nickName}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="bank-info-save-changes">
                <Button variant="main" type="submit" disabled={loading}>
                    Save Changes
                    {loading && (
                        <CircularProgress
                            size={20}
                            sx={{ marginLeft: '0.75rem', color: 'var(--primary-color)' }}
                        />
                    )}
                </Button>
            </div> */}
        </form>
    );
}
